import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { platform } from '../../../../platform/platform';
import { PLATFORM } from '../../../app.constants';
import { NetworkStatusService } from '../../../_services/network-status.service';

export type FirstActions = "synchronize" | "download" | "upload"

@Component({
    selector: 'app-first-action-guide-dialog',
    templateUrl: './first-action-guide-dialog.component.html',
    styleUrls: ['./first-action-guide-dialog.component.scss'],
    standalone: false
})
export class FirstActionGuideDialogComponent implements OnInit {

  public isBrian = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private networkStatusService: NetworkStatusService,
    private translate: TranslateService
  ) {
  }
  ngOnInit(): void {
    this.isBrian = this.networkStatusService.isBrianMode;
  }

  get isDesktop() {
    return this.networkStatusService.isDesktop();
  }

  get isOffline() {
    return this.networkStatusService.isOffline;
  }

  getUploadOrSaveText(): string {
    return this.isOffline
      ? this.translate.instant('firstActionGuideDialog.save')
      : this.translate.instant('firstActionGuideDialog.upload');
  }

}
